import React, { useState } from "react";
import "./styles.less";

export const CommonConsult = (props) => {
  const { aside, fromTag } = props;
  const [visible, setVisible] = useState(false);

  return (
    <div className="common-consult">
      <div
        onClick={() => {
          setVisible(true);
          window.open(
            fromTag
              ? `https://www.authing.cn/authingform?fromTag=${fromTag}`
              : "https://www.authing.cn/authingform"
          );
        }}
      >
        {aside}
      </div>
    </div>
  );
};
